export default "__VITE_ASSET__BxzscQax__"